export default __webpack_public_path__ + "static/media/WNo.7-9.f31c754f.jpg";